angular.module('wbDirectives').directive 'hidePage', ->
  restrict: 'A'
  scope:
    hidePage: '='
  link: ($scope, elem, attrs, ctrl) ->
    $scope.$watch 'hidePage', (hidePage) ->
      if hidePage
        setTimeout ->
          $('body').addClass('hide-page')
        , 300
      else
        $('body').removeClass('hide-page')
